<edit-header #headerDom></edit-header>
<div class="relative w-full h-full flex flex-row">
  <edit-tool-bar
    (changeSelectedSidebarIndex)="onChangeSelectedSidebarIndex($event)"
  ></edit-tool-bar>
  <div class="relative flex-none flex flex-col w-72 h-full">
    @if (selectedSidebarIndex === 0) {
      <project-selecte-tool></project-selecte-tool>
    } @else if (selectedSidebarIndex === 1) {
      <color-setting-tool></color-setting-tool>
    } @else if (selectedSidebarIndex === 2) {
      <part-setting-tool></part-setting-tool>
    } @else if (selectedSidebarIndex === 3) {
      <preset-setting-tool></preset-setting-tool>
    } @else if (selectedSidebarIndex === 4) {
      <share-setting-tool></share-setting-tool>
    }
  </div>
  <div class="relative w-full h-full shadow-inner">
    <router-outlet></router-outlet>
  </div>
</div>
